// extracted by mini-css-extract-plugin
export var form = "form-elem-module--form--hJsLj";
export var form_inner = "form-elem-module--form_inner--qbc1Y";
export var form_field = "form-elem-module--form_field--3svdQ";
export var form_submit = "form-elem-module--form_submit--22Rse";